import React from 'react';
import { NavLink } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { FaPencilAlt, FaTrash, FaEye } from 'react-icons/fa';
import { reactLocalStorage } from 'reactjs-localstorage';

import EmailTemplateAPI from '../../../api/EmailTemplateAPI';
import Display from '../../../util/Display';
import Util from '../../../util/Util';
import withRouter from '../../../util/WithRouter';
import Const from '../../../util/Constants';
import DocumentAPI from '../../../api/DocumentAPI';

class EmailTemplateList extends React.Component {

  constructor(props) {
    super(props);
    this.templates = [];
    this.state = { inApiCall: true };
    this.path = this.props.match.path;

    const model = reactLocalStorage.getObject(Const.Model).email_temp;
    this.List = Util.isAllow(model.permission, Const.PermView);
    this.Add = Util.isAllow(model.permission, Const.PermAdd);
    this.Update = Util.isAllow(model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(model.permission, Const.PermDelete);
  }

  componentDidMount() { if (this.List) EmailTemplateAPI.list(this.onReceived, this.onFail); }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = templates => { this.templates = templates; this.setState({ inApiCall: false }); };

  vewDoc = async id => {
    const res = await DocumentAPI.getPublicMediaUrl(id);
    window.open(res.url, '_blank');
  };

  confirmDelete = index => {
    Util.confirmAlert('Delete', `Are you sure you want to delete to`
      + ` ${this.templates[index].name}`, 'Delete', 'No', () => {
        this.setState({ ...this.state, inApiCall: true });
        EmailTemplateAPI.delete(this.templates[index].id, this.onDelete, this.onFail);
      });
  };
  onDelete = () => {
    Util.showNotification('Successful', 'Role Deleted successfully', 'success');
    EmailTemplateAPI.list(this.onReceived, this.onFail);
  };

  render() {
    if (!this.List) return null;
    const templatesUI = this.templates.map((template, _i) => (
      <tr key={`templates_${_i + 1}`}>
        <td>{_i + 1}</td>
        <td>{template.name}</td>
        <td>{template.subject}</td>
        <td>
          <span className="buttons add" onClick={() => this.vewDoc(template.body_html)}>
            <FaEye /> View
          </span>
        </td>
        <td>{Display.ModelLabelValue('user', template.created_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(template.created_date)}</td>
        <td>{Display.ModelLabelValue('user', template.updated_by)}</td>
        <td>{Util.serverStringToDisplayDateTime(template.updated_date)}</td>
        <td>
          {this.Update &&
            <NavLink to={`${this.path}/add-edit/${template.id}`} className="buttons update">
              <FaPencilAlt /> Update
            </NavLink>
          }
          {template.status !== Const.AlwaysActive && this.Delete &&
            <span onClick={() => this.confirmDelete(_i)} className="buttons delete">
              <FaTrash /> Delete
            </span>
          }
        </td>
      </tr>
    ));

    return (
      <div className="sectionlist pt-3">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 pb-3"><h3>Email Template</h3></div>
            <div className="col-md-6 text-right pb-3">
              { /*<NavLink to={`${this.path}/mass-email`} className="buttons success">
                Promotional Email</NavLink>*/}
              {this.Add &&
                <NavLink to={`${this.path}/add-edit/0`} className="buttons success">
                  + Add Email Template</NavLink>
              }
            </div>

            <div className="col-md-12">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Name</th>
                    <th>Subject</th>
                    <th>View</th>
                    <th>Created By</th>
                    <th>Created Date</th>
                    <th>Updated By</th>
                    <th>Updated Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>{templatesUI}</tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(EmailTemplateList);
